

export const predicate={
    name:"predicate",
    type:"(item:Type,index:Number,array:Type[]):Boolean",
    description:`
        called once for each item of the array, in ascending order, 
        until it finds one where predicate returns true
    `,
};
